/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard'
  },
  {
    path: '/services',
    view: 'Services'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/board',
    view: 'Board'
  },
  {
    path: '/pay',
    view: 'Pay'
  },
  {
    path: '/pay-sandbox',
    name: 'PaypalSandbox',
    view: 'Pay',
    props: { forceSandbox: true }
  },
  {
    path: '/about_bill',
    view: 'AboutBill'
  },
  {
    path: '/faq',
    view: 'FAQ'
  },
  {
    path: '/about',
    view: 'About'
  },
  {
    path: '/notices',
    view: 'Notices'
  }
]
